import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators'
import { AuthService } from './@core/services/auth.service';
import { KeyboardEventsService } from './@core/services/keyboard-events.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    host: {
        '(document:keydown)': 'handleKeyboardEvents($event)'
    },
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  inProgress: InteractionStatus = InteractionStatus.None;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    private keyboardEventsService: KeyboardEventsService
  ){
    this.checkAndSetActiveAccount();

    if (window.innerWidth < 900) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  isMobileResolution: boolean;

  @HostListener("window:resize", ["$event"])
  isMobile(event) {
    if (window.innerWidth < 900) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  ngOnInit(): void {

    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe((status: InteractionStatus) => {
        this.inProgress = status;
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        this.authService.getAuthorization();
        if (this.msalService.instance.getAllAccounts().length > 0) {
          this.authService.getAuthorization();
        }
      })
  }

  handleKeyboardEvents(event: KeyboardEvent) {
    this.keyboardEventsService.updated.next(event);
  }

  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
